import './footer.css';

import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Col, Row } from 'reactstrap';

const Footer = props => (
  <div className="footer page-content">
    <Row className="justify-content-center">
      <Col md="2" className="pl-2">
        <img className="img-fluid mb-3" src="static/images/logo-tix.png" alt="Logo" />
      </Col>
      <Col md="6" className="pl-2">
        <ul className="list-inline">
          <li className="list-inline-item">
            <a className="ml-0" href="/#/static/about-us">
              <Translate contentKey="static.aboutus.title">關於我們</Translate>
            </a>
          </li>
          {/*<li className="list-inline-item">
            <a href="/#/static/faq">
              <Translate contentKey="static.faq.title">常見問題</Translate>
            </a>
          </li>*/}
          <li className="list-inline-item">
            <a href="/#/static/tnc">
              <Translate contentKey="static.tnc.title">使用條款</Translate>
            </a>
          </li>
          <li className="list-inline-item">
            <a href="/#/static/privacy">
              <Translate contentKey="static.privacy.title">私隱政策</Translate>
            </a>
          </li>
          <li className="list-inline-item">
            <a href="/#/static/opportunity">
              <Translate contentKey="static.opportunity.title">合作機會</Translate>
            </a>
          </li>
          <li className="list-inline-item">
            <a href="/#/static/contact-us">
              <Translate contentKey="static.contactus.title">聯絡我們</Translate>
            </a>
          </li>
        </ul>
        <p>Copyright © 2025 PATO ENTERTAINMENT LIMITED 版權所有 不得轉載</p>
      </Col>
    </Row>
  </div>
);

export default Footer;
